<template>
    <div style="height: 100%; overflow: auto">
        <b-tabs id="rsaAccettazioneViewTabComponent" ref="rsaAccettazioneViewTabComponent" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
            <b-tab id="tbAnagrafica" title="Anagrafica">
                <rsa-accettazione-anagrafica-view-component ref="cmpRsaAccettazioneAnagraficaViewComponent"></rsa-accettazione-anagrafica-view-component>
            </b-tab>
            <b-tab v-if="jsonData.regime === 'AMBULATORIALE'" id="tbRsaSchedaPaziente" title="Scheda Paziente">
                <rsa-scheda-paziente-view-component ref="cmpRsaSchedaPaziente" @afterLoadData="onAfterLoadDataSchedaPaziente"></rsa-scheda-paziente-view-component>
            </b-tab>
            <b-tab id="tbRsaPersoneRiferimento" title="Persone di Riferimento">
                <!--    <div class="sa-tab-scroll">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="listaPersoneRiferimento" :fields="fieldsPersoneRiferimento" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template v-slot:cell(nominativo)="{ item }">
                            <span class="sa-table-span-label-primary">{{ item.nome }} {{ item.cognome }}</span>
                            <span class="sa-table-span-label-secondary">{{ item.identificativo }}</span>
                        </template>
                        <template v-slot:cell(cellulare)="{ item }">
                            <span v-if="item.cellulare">{{ item.cellulare }}</span> <span v-else>{{ item.telefonoFisso }}</span>
                        </template>
                    </b-table>
                </div> -->
                <rsa-persona-riferimento-component ref="cmpRsaPersonaRiferimento" :jsonData="jsonData" :isViewMode="true"></rsa-persona-riferimento-component>
            </b-tab>
            <b-tab id="tbRsaImpegnativa" title="Impegnativa">
                <rsa-accettazione-impegnativa-list-component ref="RsaAccettazioneImpegnativaListComponent" :idAccettazione="id" :jsonData="jsonData" :isViewMode="true" />
            </b-tab>
            <b-tab id="tbSpeseExtra" title="Spese Extra">
                <rsa-spesa-extra-list-component ref="cmpRsaSpeseExtraListComponent" :isViewMode="true"> </rsa-spesa-extra-list-component>
            </b-tab>
            <b-tab id="tbRsaEsenzioni" title="Esenzioni" v-if="tbRsaEsenzioni">
                <div class="sa-tab-scroll">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.esenzioni" :fields="fieldsEsenzioni" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="jsonData">
                            {{ jsonData.index + 1 }}
                        </template>
                        <template #cell(etichetta)="item">
                            <span class="sa-data">{{ item.item.etichetta }}</span>
                        </template>
                        <template #cell(dataInserimento)="item">
                            <span class="sa-data">{{ item.item.dataInserimento }}</span>
                        </template>
                        <template #cell(scadenza)="item">
                            <span class="sa-data">{{ item.item.scadenza }}</span>
                        </template>
                    </b-table>
                </div>
            </b-tab>
            <!--   <b-tab id="tbRsaValutazioneIngresso" title="Valutazione All'Ingresso"> 
                <rsa-paziente-valutazione-ingresso-list-component ref="RsaPazienteValutazioneIngressoListCmp" />
            </b-tab> -->
            <b-tab id="tbRsaDatiFatturazione" title="Dati di Fatturazione">
                <rsa-accettazione-dati-fatturazione-list-component ref="cmpRsaAccettazioneDatiFatturazioneComponent" :isViewMode="true"></rsa-accettazione-dati-fatturazione-list-component>
            </b-tab>
            <b-tab id="tbConsensi" title="Consensi">
                <accettazione-consensi-list-component ref="cmpAccettazioneConsensiListComponent"></accettazione-consensi-list-component>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import axios from "axios";
import "vue2-datepicker/index.css";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaAccettazioneAnagraficaViewComponent from "./RsaAccettazioneAnagraficaViewComponent.vue";
import RsaSpesaExtraListComponent from "./RsaSpesaExtraListComponent.vue";
import AccettazioneConsensiListComponent from "../../../accettazione/components/AccettazioneConsensiListComponent.vue";
import RsaAccettazioneImpegnativaListComponent from "./RsaAccettazioneImpegnativaListComponent.vue";
//import RsaPazienteValutazioneIngressoListComponent from "../../rsapaziente/components/RsaPazienteValutazioneIngressoListComponent.vue";
import RsaAccettazioneDatiFatturazioneListComponent from "./RsaAccettazioneDatiFatturazioneListComponent.vue";
import RsaSchedaPazienteViewComponent from "./RsaSchedaPazienteViewComponent.vue";
import RsaPersonaRiferimentoComponent from "../../components/RsaPersonaRiferimentoComponent.vue";

export default {
    props: {},
    mixins: [UtilityMixin],
    components: {
        RsaAccettazioneAnagraficaViewComponent,
        RsaSpesaExtraListComponent,
        AccettazioneConsensiListComponent,
        RsaAccettazioneImpegnativaListComponent,
        //  RsaPazienteValutazioneIngressoListComponent,
        RsaAccettazioneDatiFatturazioneListComponent,
        RsaSchedaPazienteViewComponent,
        RsaPersonaRiferimentoComponent,
    },
    data() {
        return {
            pathResource: "/rsaaccettazioni",
            pathResourcePresidio: "/strutturepresidi",
            pathResourceComuniByCodiceIstat: "/comuni/istat",
            pathResourcePersoneRiferimento: "/rsapersoneriferimento",
            showModalLoading: false,
            listKey: 0,
            rows: 0,
            perPage: 50,
            currentPage: 1,
            id: null,
            presidio: "",
            comuneNascita: "",
            comuneResidenza: "",
            isViewMode: true,
            comuneDomicilio: "",
            tbRsaDatiFatturazione: false,
            tbRsaEsenzioni: false,
            activeTabIndex: 0,
            jsonData: {
                codiceStruttura: null, //non a video
                idPresidio: null, //non a video
                numero: null, //non a video
                note: null, //non a video
                regime: null, //non a video
                idPrenotazione: null, //non a video
                accettazioneStruttura: {}, //non a video
                accettazioneAnagrafica: {
                    idAccettazione: null, //non a video
                    tipo: null, //non a video
                    identificativo: null,
                    tipoIdentificativo: null, //non a video
                    cognome: null,
                    nome: null,
                    dataNascita: null,
                    provinciaNascita: null,
                    comuneNascitaCodiceIstat: null,
                    sesso: null,
                    regioneResidenza: null,
                    provinciaResidenza: null,
                    comuneResidenzaCodiceIstat: null,
                    indirizzoResidenza: null,
                    capResidenza: null,
                    regioneDomicilio: null,
                    provinciaDomicilio: null,
                    comuneDomicilioCodiceIstat: null,
                    indirizzoDomicilio: null,
                    capDomicilio: null,
                    note: null,
                    medicoCurante: null,
                    codiceFiscaleMedicoCurante: null, //non a video
                    telefono: null,
                    email: null,
                    emailMedicoCurante: null,
                },
                accettazioneStati: [],
                accettazionePrestazioni: [],
                accettazioniAsl: {},
            },
            listaPersoneRiferimento: [],
            filtroPersoneRiferimento: {},
            fieldsPersoneRiferimento: [
                { label: "", key: "index" },
                {
                    label: "Nominativo",
                    key: "nominativo",
                },
                {
                    label: "Recapito Telefonico",
                    key: "cellulare",
                },
                {
                    label: "Email",
                    key: "email",
                },
                {
                    label: "Grado di relazione",
                    key: "gradoRelazione",
                },
                /* {
          label: "",
          key: "actions",
        }, */
            ],
            fieldsEsenzioni: [
                { label: "", key: "index" },
                {
                    label: "Etichetta",
                    key: "etichetta",
                },
                {
                    label: "Data inserimento",
                    key: "dataInserimento",
                },
                {
                    label: "Scadenza",
                    key: "scadenza",
                },
            ],
            fieldsPatologia: [
                { label: "", key: "index" },
                { label: "Patolgia", key: "patologia" },
                { label: "Descrizione Patologia", key: "descrizionePatologia" },
                { label: "CodiceIcdIx", key: "codiceIcdIx" },
            ],
        };
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id ? this.$route.params.id : this.$route.query.idAccettazione;
        me.loadDataAccettazione();
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        onInputTabs(index) {
            let me = this;
            let activeTab = this.$refs.rsaAccettazioneViewTabComponent.getTabs()[index];
            me.activeTab(activeTab.id);
        },
        activeTab(idActiveTab) {
            let me = this;
            me.$emit("updateIdDocumentRepository", me.id);
            switch (idActiveTab) {
                case "tbPersonaRiferimento":
                    me.loadPersoneRiferimento();
                    break;
                case "tbRsaValutazioneIngresso":
                    me.$refs.RsaPazienteValutazioneIngressoListCmp.init(me.id);

                    break;
                case "tbRsaImpegnativa":
                    me.$refs.RsaAccettazioneImpegnativaListComponent.loadData();
                    break;
                case "tbSpeseExtra":
                    me.$refs.cmpRsaSpeseExtraListComponent.loadData();
                    break;
                case "tbConsensi":
                    me.$refs.cmpAccettazioneConsensiListComponent.setDati(me.id, me.jsonData, "NURITY");
                    break;
                case "tbRsaDatiFatturazione":
                    me.$refs.cmpRsaAccettazioneDatiFatturazioneComponent.init(me.jsonData);
                    break;
                case "tbRsaSchedaPaziente":
                    me.$refs.cmpRsaSchedaPaziente.init(me.jsonData);
                    break;
                case "tbRsaPersoneRiferimento":
                    me.$refs.cmpRsaPersonaRiferimento.init(me.id);
                    break;

                /* case "tbSpeseExtra":
                    me.$refs.RsaSpesaExtraListComponent.loadData(); */
            }
        },
        setId(id) {
            let me = this;
            me.id = id;
            me.$refs.cmpRsaAccettazioneAnagraficaViewComponent.setId(id);
            me.$refs.cmpRsaSpeseExtraListComponent.setId(id);
        },
        loadPersoneRiferimento() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePersoneRiferimento;
            let params = { idAccettazione: me.id };
            axios.get(link, { params: params }).then((response) => {
                me.listaPersoneRiferimento = response.data.data.list;
            });
        },
        //     loadSpeseExtra() {
        //         this.$refs.cmpRsaSpeseExtra.loadData();
        //     },
        loadDataAccettazione() {
            let me = this;
            me.$emit("beforeLoadData");
            /* console.log(me.id === "-1"); */
            if (me.id === "-1") {
                me.$emit("afterLoadData");
                me.isTabDisabled = true;
            } else {
                me.isCheckIdentificativo = true;
                me.showModalLoading = true;
                me.isTabDisabled = false;
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                axios
                    .get(link + me.id)
                    .then((response) => {
                        me.jsonData = response.data.data;
                        me.$emit("afterLoadData");
                    })
                    .catch(() => {});
            }
        },
        onAfterLoadDataSchedaPaziente(data) {
            let me = this;
            me.$emit("updateIdDocumentRepository", data.id);
        },
    },
};
</script>
